import React from "react";
import { useSelector } from "react-redux";
import { useTheme } from "@material-ui/core/styles";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Label,
  ResponsiveContainer,
} from "recharts";
import Title from "../Title";
import moment from "moment";

// Generate Sales Data
function createData(date, quantity) {
  return { date, quantity };
}

export default function GraficoEvoTurnos() {
  const theme = useTheme();
  const { cantXFecha } = useSelector( (state) => state.indicadores );

  const data = cantXFecha.slice(-8).map((s) => {
    return createData(
      moment(s.fecha_alta).isValid()
        ? moment(s.fecha_alta).format('L')
        : 0,
      s.cantidad
    );
  });

  return (
    <React.Fragment>
      <Title>Evolución Turnos Tomados por Día</Title>
      <ResponsiveContainer>
        <LineChart
          data={data}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 24,
          }}
        >
          <XAxis dataKey="date" stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary}>
            <Label
              angle={270}
              position="left"
              style={{ textAnchor: "middle", fill: theme.palette.text.primary }}
            >
              Cantidad
            </Label>
          </YAxis>
          <Line
            type="monotone"
            dataKey="quantity"
            stroke={theme.palette.primary.main}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}
